<div class="accordion" id="productAccordion">
  <div class="accordion-item" *ngFor="let product of ProductD; let i = index">
    <h2 class="accordion-header" id="heading{{ i }}">
      <button class="accordion-button" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#collapse' + i"
        aria-expanded="false" [attr.aria-controls]="'collapse' + i">
        {{ product.productName }}
      </button>
    </h2>

    <div [id]="'collapse' + i" class="accordion-collapse collapse" [attr.aria-labelledby]="'heading' + i"
      data-bs-parent="#productAccordion">
      <div class="accordion-body">
        <!-- Product-level inputs -->
        <div class="row mb-3">
          <div class="col-lg-3 col-md-3 col-sm-3 col-12">
            <label for="price" class="fw-semibold">Price (₹)</label>
            <input type="number" class="form-control" id="price" name="price" placeholder="Enter Price" [(ngModel)]="product.price" />
          </div>

          <div class="col-lg-3 col-md-3 col-sm-3 col-12">
            <label for="targetProd" class="fw-semibold">Target Production</label>
            <input type="number" class="form-control" id="targetProd" name="targetProd" placeholder="Enter Target Production" [(ngModel)]="product.targetProduction" />
          </div>

          <div class="col-lg-3 col-md-3 col-sm-3 col-12">
            <label for="qtyLevel" class="fw-semibold">Quality Level (0–10)</label>
            <input type="number" min="0" max="10" class="form-control" id="qtyLevel" name="qtyLevel" placeholder="Enter Quality Level" [(ngModel)]="product.qualityLevel" />
          </div>

          <div class="col-lg-3 col-md-3 col-sm-3 col-12">
            <label for="buyMarktReport" class="fw-semibold">Buy Market Perception Report?</label>
            <select class="form-select" [(ngModel)]="product.marketPerceptionReport" id="buyMarktReport" name="buyMarktReport">
              <option value="Y">Yes</option>
              <option value="N">No</option>
            </select>
          </div>
        </div>

        <hr />

        <!-- Features Grid -->
        <div class="container-fluid">
          <div class="row g-3">
            <div class="col-md-3" *ngFor="let feat of product.features; let j = index">
              <div class="border rounded p-2 h-100">
                <label class="fw-semibold d-block mb-2">{{ feat.featureName }}</label>

                <!-- Checkbox feature -->
                <div *ngIf="feat.featureType === 'C'">
                  <input type="checkbox" [checked]="feat.selectedValue === 'Y'" (change)="toggleCheckbox(feat)" />
                </div>


                <!-- Single Select feature -->
                <div *ngIf="feat.featureType === 'S'">
                  <select class="form-select" [(ngModel)]="feat.selectedValue"
                    (change)="onFeatureChange(product, feat)">
                    <option value="-">Select</option>
                    <option *ngFor="let val of feat.featureValues" [value]="val">
                      {{ val }}
                    </option>
                  </select>
                </div>

                <!-- Multi Select feature -->
                <div *ngIf="feat.featureType === 'M'">
                  <ngx-select-dropdown [options]="feat.featureValues" [(ngModel)]="feat.selectedValue"
                    [config]="multiSelectConfig" (change)="onFeatureChange(product, feat)"></ngx-select-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>